import { MaterialIcons } from "@expo/vector-icons";
import { Center, Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";
import { TouchableOpacity } from "react-native";

import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import { currentVersion } from "@/utils/platform";

import { options } from "./options";
import { SettingsListItemProps, SettingsProps } from "./types";

const ListItem = ({ iconName, title, onPress }: SettingsListItemProps) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <HStack w="full" py="4" justifyContent="space-between" alignItems="center">
        <HStack alignItems="center">
          <Icon as={<MaterialIcons name={iconName as any} />} color="primary.600" size="lg" />
          <Text px="4">{title}</Text>
        </HStack>
        <Icon as={<MaterialIcons name="arrow-forward-ios" />} color="primary.600" size="lg" />
      </HStack>
      <Divider />
    </TouchableOpacity>
  );
};

const SettingsMobile = ({ userName, onBackPress, onPressLogout, onOptionPress }: SettingsProps) => {
  return (
    <Container Header={<MobileHeader title="Ajustes" onBackPress={() => onBackPress()} />}>
      <Text fontSize="lg" color="primary.600" py="4" bold>
        Olá, {userName}
      </Text>
      {options.map(({ session, options }) => (
        <VStack key={session} py="2">
          <Text fontSize="md" color="primary.600">
            {session}
          </Text>
          {options.map((option) => (
            <ListItem
              key={option.title}
              title={option.title}
              iconName={option.iconName}
              onPress={() => onOptionPress(option)}
            />
          ))}
        </VStack>
      ))}
      <TouchableOpacity onPress={onPressLogout}>
        <HStack w="full" py="4" pt="8" alignItems="center">
          <Icon as={<MaterialIcons name="logout" />} color="red.600" size="lg" />
          <Text px="4" color="red.600">
            Sair
          </Text>
        </HStack>
      </TouchableOpacity>
      <Divider />
      <Center py="4" mb="32">
        <Text>iFeira v{currentVersion}</Text>
      </Center>
    </Container>
  );
};

export default SettingsMobile;
